module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showFuelCut) ? _c('div', {
    staticClass: "fuel-cut-control"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.active
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("\n        Cortar suministro\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#83c554"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.active
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("\n        Restablecer suministro\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-left": "1px solid grey",
      "margin": "0 10px",
      "height": "70px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "state-container"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.activeLabel) + " ")]), _vm._v(" "), (_vm.running) ? _c('spinner') : _c('img', {
    attrs: {
      "width": "64px",
      "src": _vm.activeIcon,
      "alt": "fuel"
    }
  })], 1)])]), _vm._v(" "), _c('yes-no-modal', {
    attrs: {
      "show": _vm.showModal === _vm.modalTypes.Activate,
      "title": ("¿Está seguro que desea " + (this.active ? 'desactivar' : 'activar') + " el corte de combustible?")
    },
    on: {
      "pressed-no": function($event) {
        return _vm.hideModal()
      },
      "pressed-yes": function($event) {
        return _vm.executeAction()
      }
    }
  }, [_c('p', [_vm._v(" De hacerlo, el vehículo "), _c('b', [_vm._v(_vm._s(this.active ? 'podrá volver a' : 'no podrá'))]), _vm._v(" circular. ")])]), _vm._v(" "), _c('info-modal', {
    attrs: {
      "show": _vm.showModal === _vm.modalTypes.Running,
      "title": ((this.active ? 'Desactivando' : 'Activando') + " corte de combustible...")
    },
    on: {
      "pressed-ok": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_c('spinner')], 1), _vm._v(" "), _c('info-modal', {
    attrs: {
      "show": _vm.showModal === _vm.modalTypes.Error,
      "title": ("Ha ocurrido un error al " + (this.active ? 'desactivat' : 'activar') + " el corte de combustible...")
    },
    on: {
      "pressed-ok": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta-dark"
    }
  }, [_c('h4', [_vm._v("Corte de combustible")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-109115e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/FuelCut.vue
// module id = 241
// module chunks = 3